import Admins from '@/pages/Admins.vue';
import Advances from '@/pages/Advances.vue';
import CompanySettings from '@/pages/CompanySettings.vue';
import EmailActions from '@/pages/EmailActions';
import EmployeeDeactivate from '@/pages/EmployeeDeactivate.vue';
import EmployeeInvite from '@/pages/EmployeeInvite.vue';
import EmployeeOptIn from '@/pages/EmployeeOptIn.vue';
import EmployeeOptOut from '@/pages/EmployeeOptOut.vue';
import EmployeePause from '@/pages/EmployeePause.vue';
import EmployeeRehire from '@/pages/EmployeeRehire.vue';
import EmployeeTerminate from '@/pages/EmployeeTerminate.vue';
import EmployeeResetPassword from '@/pages/EmployeeResetPassword.vue';
import EmployeeRevertBanking from '@/pages/EmployeeRevertBanking.vue';
import EmployeeUnpause from '@/pages/EmployeeUnpause.vue';
import EmployeesUpload from '@/pages/EmployeesUpload.vue';
import EmployeesReinvite from '@/pages/EmployeesReinvite.vue';
import EnrollEmployee from '@/pages/EnrollEmployee.vue';
import EnrollEmployeeLoading from '@/pages/EnrollEmployeeLoading.vue';
import ForgotPassword from '@/pages/ForgotPassword.vue';
import FundingDetails from '@/pages/FundingDetails.vue';
import FundingWithdraw from '@/pages/FundingWithdraw.vue';
import Impersonate from '@/pages/Impersonate.vue';
import ImportEmployees from '@/pages/ImportEmployees.vue';
import IntegrationsOauth2 from '@/pages/IntegrationsOauth2.vue';
import KYC from '@/pages/KYC.vue';
import LeadTouch from '@/pages/LeadTouch.vue';
import Login from '@/pages/Login.vue';
import Profile from '@/pages/Profile.vue';
import Referral from '@/pages/Referral.vue';
import SftpBulkUpload from '@/pages/SftpBulkUpload';
import ShiftsAdd from '@/pages/ShiftAdd.vue';
import ShiftsUpload from '@/pages/ShiftsUpload.vue';
import VerifyOwnership from '@/pages/VerifyOwnership.vue';
import WhatsAppRedirect from '@/pages/WhatsAppRedirect.vue';
import WhatsAppTermsAmendmentV1 from '@/pages/WhatsAppTermsAmendmentV1.vue';

import Absences from '@/pages/absences/Absences.vue';
import Jobs from '@/pages/jobs/Jobs.vue';
import AdminAdd from '@/pages/adminAdd/AdminAdd.vue';
import AnalyticsApp from '@/pages/analyticsApp/AnalyticsApp.vue';
import AnalyticsBankPay from '@/pages/analyticsBankPay/AnalyticsBankPay.vue';
import AnalyticsBenchmark from '@/pages/analyticsBenchmark/AnalyticsBenchmark.vue';
import AnalyticsBudget from '@/pages/analyticsBudget/AnalyticsBudget.vue';
import AnalyticsCompare from '@/pages/analyticsCompare/AnalyticsCompare.vue';
import AnalyticsEducation from '@/pages/analyticsEducation/AnalyticsEducation.vue';
import AnalyticsHomepage from '@/pages/analyticsHomepage/AnalyticsHomepage.vue';
import AnalyticsLoans from '@/pages/analyticsLoans/AnalyticsLoans.vue';
import AnalyticsFindCombine from '@/pages/analyticsFindCombine/AnalyticsFindCombine.vue';
import AnalyticsPay from '@/pages/analyticsPay/AnalyticsPay.vue';
import AnalyticsRewards from '@/pages/analyticsRewards/AnalyticsRewards.vue';
import AnalyticsSafeguarding from '@/pages/analyticsSafeguarding/AnalyticsSafeguarding.vue';
import AnalyticsSavings from '@/pages/analyticsSavings/AnalyticsSavings.vue';
import AnalyticsShifts from '@/pages/analyticsShifts/AnalyticsShifts.vue';
import AnalyticsSupport from '@/pages/analyticsSupport/AnalyticsSupport.vue';
import BankPay from '@/pages/bankPay/BankPay.vue';
import Dashboard from '@/pages/dashboard/Dashboard.vue';
import EmployeeFeedback from '@/pages/feedback/EmployeeFeedback.vue';
import Divisions from '@/pages/divisions';
import DivisionsAdd from '@/pages/divisions/add';
import Division from '@/pages/divisions/division';
import DivisionEmployeeAdd from '@/pages/divisions/division/employees/add';
import DivisionManagerAdd from '@/pages/divisions/division/managers/add';
import Employee from '@/pages/employee/Employee.vue';
import EmployeeAdd from '@/pages/employeeAdd/EmployeeAdd.vue';
import Employees from '@/pages/employees/Employees.vue';
import FundingPosition from '@/pages/funding-position/index.vue';
import Integrations from '@/pages/integrations/Integrations.vue';
import OffCyclePayments from '@/pages/offCyclePayments/index.vue';
import PayWithWagestream from '@/pages/payWithWagestream/PayWithWagestream.vue';
import PaySchedule from '@/pages/payschedule/PaySchedule.vue';
import PaySchedules from '@/pages/payschedules/PaySchedules.vue';
import RegisterIntegrate from '@/pages/registerIntegrate/RegisterIntegrate.vue';
import ResetPassword from '@/pages/ResetPassword.vue';
import Recognition from '@/pages/recognition/Recognition.vue';
import RecognitionCreateProgramAward from '@/pages/recognition/award-types/program/CreateProgramAward.vue';
import RecognitionCreateOpenAward from '@/pages/recognition/award-types/open/CreateOpenAward.vue';
import RecognitionCreateMilestoneAward from '@/pages/recognition/award-types/milestone/CreateMilestoneAward.vue';
import RecognitionAwardDetail from '@/pages/recognition/AwardDetail.vue';
import RewardsSettings from '@/pages/recognition/RewardsSettings.vue';
import Shifts from '@/pages/shifts/Shifts.vue';
import StreamedWages from '@/pages/streamed-wages/index.vue';
import EmployeePayments from '@/pages/employee-payments/index.vue';
import SalarySettlement from '@/pages/salary-settlement/index.vue';
import Subscription from '@/pages/subscription';
import Tenancy from '@/pages/tenancy';
import OneTimePayments from '@/pages/one-time-payments';
import SuccessfulStripeIntentRedirect from '@/pages/SuccessfulStripeIntentRedirect.vue';
import ADPLogin from '@/pages/ADPLogin.vue';
import ADPLoginCallback from '@/pages/ADPLoginCallback.vue';

import useFeatureFlags from '@/composables/useFeatureFlags';
import useProductAvailability from '@/composables/useProductAvailability';
import useProductsWithData from '@/composables/useProductsWithData';
import State from '@/state/State';
import { canCompleteBankingReturnAtAll, canTerminateEmployeesAtAll } from '@/utils/Employee';
import HelpCenter from '@/pages/helpCenter/HelpCenter.vue';
import Help from '@/pages/Help.vue';
import LastDayPayReport from '@/pages/lastDayPayReport/LastDayPayReport.vue';
import PayMultiple from '@/pages/one-time-payments/pages/pay-multiple.vue';
import SingleBatch from '@/pages/one-time-payments/pages/single-batch.vue';
import OneTimePaymentsInvoices from '@/pages/one-time-payments/pages/invoices.vue';
import RecentUploads from '@/pages/RecentUploads.vue';
import EmployeeBankingMismatchUpdate from '@/pages/EmployeeBankingMismatchUpdate.vue';
import SecureFileTransfer from '@/components/SecureFileTransfer.vue';

const PartnersLanding = () => import(/* webpackChunkName: "partners" */ '@/pages/PartnersLanding.vue');
const ApiDocumentation = () => import(/* webpackChunkName: "partners" */ '@/pages/PartnersApiDocumentation.vue');
const Onboarding = () => import(/* webpackChunkName: "onboarding" */ '@/pages/Onboarding.vue');
const OnboardingStageQuestionnaire = () =>
  import(/* webpackChunkName: "onboarding" */ '@/pages/OnboardingStageQuestionnaire.vue');
const OnboardingTestingStage = () => import(/* webpackChunkName: "onboarding" */ '@/pages/OnboardingTestingStage.vue');
const RecognitionDuplicateAwardSource = () =>
  import(/* webpackChunkName: "recognition-editor" */ '@/pages/recognition/DuplicateAwardSource.vue');
const RecognitionAwardGroupEditorPage = () =>
  import(/* webpackChunkName: "recognition-editor" */ '@/pages/recognition/AwardGroupEditorPage.vue');
const Reporting = () => import(/* webpackChunkName: "reporting" */ '@/pages/reporting/index.vue');
const Policies = () => import(/* webpackChunkName: "policies" */ '@/pages/policies/Policies.vue');
const Deductions = () => import(/* webpackChunkName: "deductions" */ '@/pages/deductions/Deductions.vue');

const {
  isDisablePayscheduleEditing,
  isDisablePayWithWagestream,
  isEnableStreamedWagesPage,
  isEnableShowPayschedulesOnStreamedWagesPage,
  isEnableEmployeePaymentsPage,
  isEnableReportingPage,
  isEnableBankPayHistory,
  isEnableLastDayPay,
  isUkCompany,
  isDisableSelfServiceReinviteEmail,
  offCyclePaymentsVersion,
  showDeductionsFiles,
  deductionsPortalVersion,
  recognitionVersion,
  coachPolicyDocumentsVersion,
  canAddJobs,
  canViewJobs,
  portalUpdatesJan2026Enabled,
  isSafeguardingEnabled,
  hideSalaryView,
  isUsCompany,
  isFundingPositionPageDisabled,
} = useFeatureFlags();

const { isBuildEnabled, isCoachEnabled, isBudgetEnabled, isRewardsEnabled, isSdlEnabled, isPensionFindCombineEnabled } =
  useProductAvailability();

const {
  hasPayData,
  hasLoansData,
  hasSavingsData,
  hasBudgetData,
  hasRewardsData,
  hasFindCombineData,
  hasEducationData,
} = useProductsWithData();

const jobsGuard = () => canAddJobs.value || canViewJobs.value;

export const publicRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: '/referral',
    name: 'referral',
    component: Referral,
  },
  {
    path: '/login/impersonate',
    name: 'login-impersonate',
    component: Impersonate,
  },
  {
    path: '/login/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/register/integrate',
    name: 'sme-register-page-integrate',
    component: RegisterIntegrate,
  },
  // misc
  {
    path: '/touch/:point(.*)',
    name: 'sme-lead-touch',
    component: LeadTouch,
  },
  {
    path: '/partners',
    name: 'sme-partners',
    component: PartnersLanding,
  },
  {
    path: '/partners/api',
    name: 'sme-partners-api',
    component: ApiDocumentation,
  },
  {
    path: '/adp-login',
    name: 'adp-login',
    component: ADPLogin,
  },
  {
    path: '/adp-login-callback',
    name: 'adp-login-callback',
    component: ADPLoginCallback,
  },
  {
    path: '/whatsapp-enroll',
    name: 'sme-whats-app-redirect',
    component: WhatsAppRedirect,
  },
  {
    path: '/terms/whatsapp-v1',
    name: 'sme-whats-app-terms-amendment-v1',
    component: WhatsAppTermsAmendmentV1,
  },
  // FIXME: I had to move these to unauthorized to get unit test to pass because couldnt mock endpoint auth.
  //        This is certainly my own incompetence but having these unprotected in UI routing is not a risk.
  {
    path: '/authorize/:provider/:company_id?',
    name: 'sme-oauth2',
    component: IntegrationsOauth2,
  },
];

export const flexpayRoutes = [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
  },
  // Before the questionnaire route, which would otherwise match it.
  {
    path: '/onboarding/testing',
    name: 'onboarding-testing',
    component: OnboardingTestingStage,
  },
  {
    path: '/onboarding/:stageId',
    name: 'onboarding-stage',
    component: OnboardingStageQuestionnaire,
    props: true,
  },
  {
    path: '/dashboard',
    redirect: '/sme-dashboard',
  },
  {
    path: '/sme-dashboard',
    name: 'sme-dashboard',
    component: Dashboard,
  },
  {
    path: '/sme-dashboard/feedback',
    name: 'employee-feedback',
    component: EmployeeFeedback,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
  },
  {
    path: '/divisions',
    name: 'divisions',
    component: Divisions,
    meta: {
      guards: [() => !isUsCompany.value],
    },
  },
  {
    path: '/divisions/add',
    name: 'divisions-add',
    component: DivisionsAdd,
    props: true,
    meta: {
      guards: [() => !isUsCompany.value],
    },
  },
  {
    path: '/divisions/:divisionId',
    name: 'division',
    component: Division,
    props: true,
    meta: {
      guards: [() => !isUsCompany.value],
    },
  },
  {
    path: '/divisions/:divisionId/managers/add',
    name: 'division-managers-add',
    component: DivisionManagerAdd,
    props: true,
    meta: {
      guards: [() => !isUsCompany.value],
    },
  },
  {
    path: '/divisions/:divisionId/employees/add',
    name: 'division-employees-add',
    component: DivisionEmployeeAdd,
    props: true,
    meta: {
      guards: [() => !isUsCompany.value],
    },
  },
  {
    path: '/employees',
    name: 'employees',
    component: Employees,
  },
  {
    path: '/employees/add',
    name: 'employees-add',
    component: EmployeeAdd,
  },
  {
    path: '/employees/bulk',
    name: 'employees-upload',
    component: EmployeesUpload,
  },
  {
    path: '/employees/reinvite',
    name: 'employees-reinvite',
    component: EmployeesReinvite,
    meta: {
      guards: [() => isUkCompany.value && !isDisableSelfServiceReinviteEmail.value],
    },
  },
  {
    path: '/employees/upload',
    redirect: '/employees/bulk',
  },
  {
    path: '/employees/:employeeId',
    name: 'employee',
    component: Employee,
    props: true,
  },
  {
    path: '/employees/:employeeId/setup', //used when enrolling an employee
    name: 'employee-setup',
    component: EnrollEmployee,
    props: true,
  },
  {
    path: '/employees/:employeeId/activate', //used to poll employee for bank details after enrolling employee
    name: 'employee-activate',
    component: EnrollEmployeeLoading,
    props: true,
  },
  {
    path: '/employees/:employeeId/opt-out',
    name: 'employee-opt-out',
    component: EmployeeOptOut,
    props: true,
  },
  {
    path: '/employees/:employeeId/opt-in',
    name: 'employee-opt-in',
    component: EmployeeOptIn,
    props: true,
  },
  {
    path: '/employees/:employeeId/terminate',
    name: 'employee-terminate',
    component: EmployeeTerminate,
    props: true,
    meta: {
      guards: [canTerminateEmployeesAtAll],
    },
  },
  {
    path: '/employees/:employeeId/rehire',
    name: 'employee-rehire',
    component: EmployeeRehire,
    props: true,
    meta: {
      guards: [canTerminateEmployeesAtAll],
    },
  },
  {
    path: '/employees/:employeeId/revert-banking', // for reverting bank details on user's payroll. currently unused
    name: 'employee-revert-banking',
    component: EmployeeRevertBanking,
    props: true,
    meta: {
      guards: [canCompleteBankingReturnAtAll],
    },
  },
  {
    path: '/employees/:employeeId/complete-unenrolment',
    name: 'employee-complete-unenrolment',
    component: EmployeeRevertBanking,
    props: true,
    meta: {
      guards: [canCompleteBankingReturnAtAll],
    },
  },
  {
    path: '/employees/:employeeId/employee-banking-mismatch-update',
    name: 'employee-banking-mismatch-update',
    component: EmployeeBankingMismatchUpdate,
    props: true,
  },
  {
    path: '/employees/:employeeId/pause',
    name: 'employee-pause',
    component: EmployeePause,
    props: true,
  },
  {
    path: '/employees/:employeeId/unpause',
    name: 'employee-unpause',
    component: EmployeeUnpause,
    props: true,
  },
  {
    path: '/employees/:employeeId/reset-password',
    name: 'employee-reset-password',
    component: EmployeeResetPassword,
    props: true,
  },
  {
    path: '/employees/:employeeId/invite',
    name: 'employee-invite',
    component: EmployeeInvite,
    props: true,
  },
  {
    path: '/employees/:employeeId/deactivate',
    name: 'employee-deactivate',
    component: EmployeeDeactivate,
    props: true,
  },
  {
    path: '/advances',
    name: 'sme-advances',
    component: Advances,
  },
  {
    path: '/streams',
    name: 'streams',
    component: StreamedWages,
    meta: {
      guards: [() => isEnableStreamedWagesPage.value || isEnableShowPayschedulesOnStreamedWagesPage.value],
    },
  },
  {
    path: '/employe-payments',
    name: 'employee-payments',
    component: EmployeePayments,
    meta: {
      guards: [() => isEnableEmployeePaymentsPage.value && !hideSalaryView.value],
    },
  },
  {
    path: '/salary-settlement',
    name: 'salary-settlement',
    component: SalarySettlement,
    meta: {
      guards: [() => State.state.claims.a && !hideSalaryView.value],
    },
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: Reporting,
    meta: {
      guards: [() => isEnableReportingPage.value],
    },
  },
  {
    path: '/one-time-payments',
    name: 'one-time-payments',
    component: OneTimePayments,
    meta: {
      guards: [() => offCyclePaymentsVersion.value.includes('v2')],
    },
  },
  {
    path: '/one-time-payments/bulk-upload',
    name: 'one-time-payments-bulk',
    component: PayMultiple,
    meta: {
      guards: [() => offCyclePaymentsVersion.value.includes('v2')],
    },
  },
  {
    path: '/one-time-payments/invoices',
    name: 'one-time-payments-invoices',
    component: OneTimePaymentsInvoices,
    meta: {
      guards: [() => offCyclePaymentsVersion.value.includes('v2') || showDeductionsFiles.value],
    },
  },
  {
    path: '/one-time-payments/:batchId',
    name: 'one-time-payment',
    component: SingleBatch,
    meta: {
      guards: [() => offCyclePaymentsVersion.value.includes('v2')],
    },
  },
  {
    path: '/recognition',
    name: 'recognition',
    component: Recognition,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/create/program',
    name: 'recognition-create-program',
    component: RecognitionCreateProgramAward,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/create/open',
    name: 'recognition-create-open',
    component: RecognitionCreateOpenAward,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/create/milestone',
    name: 'recognition-create-milestone',
    component: RecognitionCreateMilestoneAward,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/settings',
    name: 'recognition-settings',
    component: RewardsSettings,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/duplicate',
    name: 'recognition-duplicate-source',
    component: RecognitionDuplicateAwardSource,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/group-editor',
    name: 'recognition-group-editor',
    component: RecognitionAwardGroupEditorPage,
    props: route => ({
      sourceId: route.query.sourceId || null,
      groupId: route.query.groupId || null,
      copies: route.query.copies ? parseInt(route.query.copies, 10) : 2,
      splitBy: route.query.splitBy || null,
      splitValues: route.query.values ? [].concat(route.query.values) : null,
    }),
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/recognition/:programId',
    name: 'recognition-award-detail',
    component: RecognitionAwardDetail,
    props: true,
    meta: {
      guards: [() => recognitionVersion.value !== 'off'],
    },
  },
  {
    path: '/shifts',
    name: 'shifts',
    component: Shifts,
  },
  {
    path: '/absences',
    name: 'absences',
    component: Absences,
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: Jobs,
    meta: {
      guards: [jobsGuard],
    },
  },
  {
    path: '/admins',
    name: 'admins',
    component: Admins,
  },
  {
    path: '/admins/add',
    name: 'admins-add',
    component: AdminAdd,
  },
  {
    path: '/company-info/pay-schedules/:payScheduleId',
    name: 'pay-schedule',
    component: PaySchedule,
    meta: {
      guards: [
        router => {
          if (!isDisablePayscheduleEditing.value) {
            return true;
          }
          return !(router.history.pending.params.payScheduleId === 'create');
        },
      ],
    },
  },
  {
    path: '/setup/employees',
    name: 'sme-employees-add',
    component: ImportEmployees,
  },
  {
    path: '/sme/funds',
    name: 'sme-funds',
    component: FundingDetails,
  },
  {
    path: '/funding-position',
    name: 'funding-position',
    component: FundingPosition,
    meta: {
      guards: [() => !isFundingPositionPageDisabled.value],
    },
  },
  {
    path: '/sme/funds/withdraw',
    name: 'sme-funds-withdraw',
    component: FundingWithdraw,
  },
  {
    path: '/sme/verify-ownership',
    name: 'sme-verify-ownership',
    component: VerifyOwnership,
  },

  {
    path: '/kyc',
    name: 'sme-kyc',
    component: KYC,
  },
  {
    path: '/sme/integrations/:provider?',
    name: 'sme-integrations',
    component: Integrations,
  },
  {
    path: '/sme/integrations-tenancy/:state',
    name: 'tenancy',
    component: Tenancy,
    props: true,
  },
  {
    path: '/shifts/bulk',
    name: 'sme-shifts-upload',
    component: ShiftsUpload,
  },
  {
    path: '/shifts/single',
    name: 'sme-shift-add',
    component: ShiftsAdd,
  },
  {
    path: '/sme/payday/',
    name: 'sme-pay-day',
    component: PaySchedules,
  },
  {
    path: 'last-day-pay',
    name: 'last-day-pay',
    component: LastDayPayReport,
    guard: [() => isEnableLastDayPay.value],
  },
  {
    path: '/sme/payment-run/',
    name: 'sme-payment-run',
    component: PayWithWagestream,
    meta: {
      guards: [() => !isDisablePayWithWagestream.value && isUkCompany.value],
    },
  },
  {
    path: '/deductions',
    name: 'deductions',
    component: Deductions,
    meta: {
      guards: [() => State.state.claims.a && deductionsPortalVersion.value === 'v1'],
    },
  },
  {
    path: '/sme/off-cycle-payments/',
    name: 'sme-off-cycle-payments',
    component: OffCyclePayments,
  },
  {
    path: '/sme/bank-pay/',
    name: 'sme-bank-pay',
    component: BankPay,
    meta: {
      guards: [() => isEnableBankPayHistory.value],
    },
  },
  {
    path: '/sme/subscription/',
    name: 'sme-subscription',
    component: Subscription,
    meta: {
      guards: [() => isUkCompany.value],
    },
  },
  {
    path: '/successful-stripe-intent-redirect',
    name: 'successful-stripe-intent-redirect',
    component: SuccessfulStripeIntentRedirect,
  },
  {
    path: '/company-settings',
    name: 'company-settings',
    component: CompanySettings,
  },
  {
    path: '/policies',
    name: 'policies',
    component: Policies,
    meta: {
      guards: [() => !!State.state.claims?.a && isCoachEnabled.value && coachPolicyDocumentsVersion.value !== 'off'],
    },
  },
  {
    path: '/analytics',
    name: 'analytics-homepage',
    component: AnalyticsHomepage,
  },
  {
    path: '/analytics/app',
    name: 'analytics-app',
    component: AnalyticsApp,
    meta: {
      guards: [() => !portalUpdatesJan2026Enabled.value],
    },
  },
  {
    path: '/analytics/support',
    name: 'analytics-support',
    component: AnalyticsSupport,
  },
  {
    path: '/analytics/shifts',
    name: 'analytics-shifts',
    component: AnalyticsShifts,
  },
  {
    path: '/analytics/bank-pay',
    name: 'analytics-bank-pay',
    component: AnalyticsBankPay,
  },
  {
    path: '/analytics/compare',
    name: 'analytics-compare',
    component: AnalyticsCompare,
  },
  {
    path: '/analytics/benchmark',
    name: 'analytics-benchmark',
    component: AnalyticsBenchmark,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && !!State.state.claims?.a],
    },
  },
  {
    path: '/analytics/safeguarding',
    name: 'analytics-safeguarding',
    component: AnalyticsSafeguarding,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isSafeguardingEnabled.value && !!State.state.claims?.a],
    },
  },
  {
    path: '/analytics/pay',
    name: 'analytics-pay',
    component: AnalyticsPay,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && hasPayData.value],
    },
  },
  {
    path: '/analytics/savings',
    name: 'analytics-savings',
    component: AnalyticsSavings,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isBuildEnabled.value && hasSavingsData.value],
    },
  },
  {
    path: '/analytics/education',
    name: 'analytics-education',
    component: AnalyticsEducation,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isCoachEnabled.value && hasEducationData.value],
    },
  },
  {
    path: '/analytics/budget',
    name: 'analytics-budget',
    component: AnalyticsBudget,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isBudgetEnabled.value && hasBudgetData.value],
    },
  },
  {
    path: '/analytics/rewards',
    name: 'analytics-rewards',
    component: AnalyticsRewards,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isRewardsEnabled.value && hasRewardsData.value],
    },
  },
  {
    path: '/analytics/loans',
    name: 'analytics-loans',
    component: AnalyticsLoans,
    meta: {
      guards: [() => portalUpdatesJan2026Enabled.value && isSdlEnabled.value && hasLoansData.value],
    },
  },
  {
    path: '/analytics/find-combine',
    name: 'analytics-find-combine',
    component: AnalyticsFindCombine,
    meta: {
      guards: [
        () => portalUpdatesJan2026Enabled.value && isPensionFindCombineEnabled.value && hasFindCombineData.value,
      ],
    },
  },
  {
    path: '/email-actions/:token',
    name: 'email-actions',
    component: EmailActions,
  },
  {
    path: '/legacy/bulk',
    name: 'sftp-bulk-upload',
    component: SftpBulkUpload,
  },
  {
    path: '/secure-file-transfer',
    name: 'secure-file-transfer',
    component: SecureFileTransfer,
  },
  {
    path: '/recent-file-uploads',
    name: 'recent-file-uploads',
    component: RecentUploads,
    meta: {
      guards: [() => State.state.company.properties.portal.show_recent_file_uploads],
    },
  },
  {
    path: '/help-center/:slug?',
    name: 'help-center',
    component: HelpCenter,
    meta: {
      guards: [() => State.state.company.properties.portal.can_view_help_center],
    },
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
    meta: {
      guards: [() => State.state.company.properties.portal.can_access_intercom],
    },
  },
];
